// Copy paste of wrapper.html script_src_load_error code with lint autofixes
// Requres jquery and jquery.log_event

/* eslint-disable no-underscore-dangle */

window.script_src_load_error = function scriptSrcLoadError(e) {
  const { src } = e.target;
  const el = $(`[src="${src}"]`).get(0);
  const params = { script_src: src };

  // TODO refactor recaptcha specific code out probably, and maybe have another script provide the localization
  if (src.match(/recaptcha/i)) {
    $(() => {
      $('#recaptcha_login').after(
        `<div class="recaptcha_error_message">
          ${zr.page.translations.RECAPTCHA_SCRIPT_LOAD_ERROR}
          ${$('<div/>').text(src).html()}
        </div>`,
      ); // html encode entities in src
    });
  }

  // Not really sure what causes an element not to be found, but let's protect against it
  if (el) {
    params.script_time = Date.now() - el.__now;
  }

  $.log_event('script_src_load_error', params);
};

// document.createElement monkeypatch which adds onerror event
(function initMonkeyPatchCreateElement(createElement) {
  document.createElement = function monkeyPatchCreateElement(tag) {
    // eslint-disable-next-line prefer-rest-params
    const el = createElement.apply(this, arguments);

    if (tag.toUpperCase() === 'SCRIPT') {
      // TODO: addEventListener?
      el.addEventListener('error', window.script_src_load_error);
      el.__now = Date.now();
    }

    return el;
  };
}(document.createElement));
